import { render, staticRenderFns } from "./AddInspectionComponent.vue?vue&type=template&id=5c904c64"
import script from "./AddInspectionComponent.vue?vue&type=script&lang=js"
export * from "./AddInspectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports